import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M15.424 8.576a.6.6 0 0 1 0 .848L12.85 12l2.575 2.576a.6.6 0 0 1-.848.848L12 12.85l-2.576 2.575a.6.6 0 1 1-.848-.848L11.15 12 8.576 9.424a.6.6 0 1 1 .848-.848L12 11.15l2.576-2.575a.6.6 0 0 1 .848 0ZM12 20.8a8.8 8.8 0 1 0 0-17.6 8.8 8.8 0 0 0 0 17.6ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      clip-rule="evenodd"
    />
  </svg>
`;
